export default __webpack_public_path__ + "_/videos/lootbox/video-dota-f6ba123d36f825ef2cc85e7a14587373d800ab79e23710a9754c70f8617a1a64.webm";